export const HELP_ARTICLE = "https://help.nexusmods.com/article/121-diagnostics-usage-data-vortex";
export const PRIVACY_POLICY = "https://help.nexusmods.com/article/20-privacy-policy";
export const MIXPANEL_PROD_TOKEN = process.env["MIXPANEL_PROD_TOKEN"] || "3f01fd6fe87f03fe7a053413929d76b7";
export const MIXPANEL_DEV_TOKEN = process.env["MIXPANEL_DEV_TOKEN"] || "404c9346f400b7e5e3c65f2b1a1f3325";
